module.exports = __webpack_public_path__ + "img/logo_kambly.272fd9a4.webp";